import { QTD_DEPENDENTES_ENUM } from '../helpers/funcoesPadroes';
import {
    retornaLabelDoValorParentesco,
    validatorParentescoEmDuplicidade,
    validatorPossui2Dependentes65anos
} from './funcoesAuxiliaresZMC';

export class CorrenteCadastroZMC {
    constructor(dependentes, parentesco, valoresForm, idadeAssociado) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.idadeAssociado = idadeAssociado;
    }

    possui9Dependentes() {
        const qtdDependentesTotais = this.dependentes.length;

        if (qtdDependentesTotais === QTD_DEPENDENTES_ENUM.nove) {
            this.arrayMsgsErro.push('Este plano permite apenas 9 dependentes.');
        }

        return this;
    }

    parentescoComAdicionalMais65() {
        if (validatorPossui2Dependentes65anos(this.dependentes, this.valoresForm, this.idadeAssociado)) {
            this.arrayMsgsErro.push('Este plano permite apenas 2 dependentes com idade maior ou igual a 65 anos. Caso a idade do titular do plano seja maior ou igual a 65, este valor é reduzido para apenas 1 dependente.');
        }

        return this;
    }

    parentescoEmDuplicidade() {
        if (validatorParentescoEmDuplicidade(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push(`${retornaLabelDoValorParentesco(this.parentesco)}`);
        }

        return this;
    }
}